// AOCEMS press coverage, organised by country.
// Each entry links to the original publication; we link out, we do not republish article bodies.

export const mediaItems = [
  // ---------- Kenya · KOCEMS ----------
  {
    country: "Kenya",
    code: "KOCEMS",
    publication: "Capital FM Kenya",
    date: "Mar 2026",
    title: "NEMA launches real-time digital platform to monitor industrial pollution",
    summary:
      "Coverage of NEMA's launch of a real-time digital platform for monitoring industrial pollution across Kenya.",
    url: "https://www.capitalfm.co.ke/news/2026/03/nema-launches-real-time-digital-platform-to-monitor-industrial-pollution/",
  },
  {
    country: "Kenya",
    code: "KOCEMS",
    publication: "Streamline Feed",
    date: "2026",
    title: "Kenya launches real-time digital platform to curb industrial pollution",
    summary:
      "Reporting on Kenya's launch of a real-time digital platform aimed at curbing industrial pollution.",
    url: "https://streamlinefeed.co.ke/news/kenya-launches-real-time-digital-platform-to-curb-industrial-pollution",
  },
  {
    country: "Kenya",
    code: "KOCEMS",
    publication: "Green Climate Network",
    date: "2026",
    title: "KOCEMS · NEMA launches AI-powered system to monitor air, water and noise pollution",
    summary:
      "Reporting on the AI-powered KOCEMS system covering air, water and noise pollution in partnership with NEMA.",
    url: "https://www.greenclimatenetwork.com/kocems-nema-launches-ai-powered-system-to-monitor-air-water-and-noise-pollution/",
  },
  {
    country: "Kenya",
    code: "KOCEMS",
    publication: "Uzalendo News",
    date: "2026",
    title: "NEMA Kenya partners with United Platform Solutions to develop KOCEMS",
    summary:
      "Coverage of the NEMA · United Platform Solutions partnership behind the Kenya Online Continuous Emissions Monitoring System.",
    url: "https://uzalendonews.co.ke/nema-kenya-in-partnership-with-united-platform-solutions-ups-develops-the-kenya-online-continuous-emissions-monitoring-system-kocems/",
  },

  // ---------- Ghana · GOCEMS ----------
  {
    country: "Ghana",
    code: "GOCEMS",
    publication: "Ghanaian Times",
    date: "2025",
    title: "Monitoring industrial emissions: EPA launches GOCEMS",
    summary:
      "Reporting on the Environmental Protection Agency's launch of GOCEMS for monitoring industrial emissions.",
    url: "https://ghanaiantimes.com.gh/monitoring-industrial-emissions-epa-launches-gocems/",
  },
  {
    country: "Ghana",
    code: "GOCEMS",
    publication: "Investment Times Online",
    date: "Aug 2025",
    title: "Ghana launches real-time emissions monitoring system to tackle pollution",
    summary:
      "Coverage of Ghana's launch of a real-time emissions monitoring system to tackle industrial pollution.",
    url: "https://investmenttimesonline.com/2025/08/12/ghana-launches-real-time-emissions-monitoring-system-to-tackle-pollution-2/",
  },
  {
    country: "Ghana",
    code: "GOCEMS",
    publication: "Ghana Extractives",
    date: "2025",
    title: "EPA launches Africa's first real-time emissions monitoring system in Ghana",
    summary:
      "Reporting on the EPA's launch of what is described as Africa's first real-time emissions monitoring system.",
    url: "https://ghextractives.com/epa-launches-africas-first-real-time-emissions-monitoring-system-in-ghana/",
  },
  {
    country: "Ghana",
    code: "GOCEMS",
    publication: "GhanaWeb",
    date: "2025",
    title: "EPA launches enhanced emission tracker system",
    summary:
      "Coverage of the EPA's launch of its enhanced emission tracker system.",
    url: "https://www.ghanawebbers.com/GhanaHomePage/NewsArchive/EPA-launches-enhanced-emission-tracker-system-2076121",
  },
  {
    country: "Ghana",
    code: "GOCEMS",
    publication: "Daily Guide Network",
    date: "2025",
    title: "EPA launches Online Continuous Emission Monitoring System",
    summary:
      "Reporting on the EPA's launch of the Online Continuous Emission Monitoring System.",
    url: "https://dailyguidenetwork.com/epa-launches-online-continuous-emission-monitoring-system/",
  },

  // ---------- Tanzania · TOCEMS ----------
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "Africa Press",
    date: "2026",
    title: "NEMC launches digital environmental monitoring in Tanzania",
    summary:
      "Coverage of the National Environment Management Council's launch of digital environmental monitoring in Tanzania.",
    url: "https://www.africa-press.net/tanzania/all-news/nemc-launches-digital-environmental-monitoring-in-tanzania",
  },
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "Daily News Tanzania",
    date: "2026",
    title: "Govt to roll out real-time pollution monitoring",
    summary:
      "Daily News Tanzania reports on the government's plan to roll out real-time pollution monitoring nationwide under NEMC.",
    url: "https://dailynews.co.tz/govt-to-roll-out-real-time-pollution-monitoring/",
  },
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "Daily News Tanzania",
    date: "2026",
    title: "PM launches digital system monitoring pollution, marking NEMC's Ruby Jubilee",
    summary:
      "The Prime Minister inaugurates Tanzania's national digital pollution monitoring system at NEMC's 40th anniversary celebrations.",
    url: "https://dailynews.co.tz/pm-launches-digital-system-monitoring-pollution-in-marking-nemcs-ruby-jubilee/",
  },
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "The Citizen",
    date: "2026",
    title: "Tanzania steps up fight against pollution with digital monitoring system",
    summary:
      "The Citizen covers Tanzania's escalation in environmental enforcement through the launch of a national digital pollution monitoring system.",
    url: "https://www.thecitizen.co.tz/tanzania/news/national/tanzania-steps-up-fight-against-pollution-with-digital-monitoring-system-5477680",
  },
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "Tanzania Insight",
    date: "2026",
    title: "PM launches digital system monitoring pollution, marking NEMC's Ruby Jubilee",
    summary:
      "Tanzania Insight reports on the Prime Minister's launch of the new digital pollution-monitoring system during NEMC's Ruby Jubilee.",
    url: "https://tanzaniainsight.com/pm-launches-digital-system-monitoring-pollution-in-marking-nemcs-ruby-jubilee/",
  },
  {
    country: "Tanzania",
    code: "TOCEMS",
    publication: "Fullshangwe Blog",
    date: "2026",
    title: "Watanzania tubadili mtazamo, tutunze mazingira — Waziri Mkuu",
    summary:
      "Swahili-language coverage of the Prime Minister's call for Tanzanians to embrace stewardship of the environment as the national digital monitoring system goes live.",
    url: "https://fullshangweblog.co.tz/2026/05/28/watanzania-tubadili-mtazamo-tutunze-mazingira-waziri-mkuu/",
  },

  // ---------- Nigeria · NIMACEMS ----------
  {
    country: "Nigeria",
    code: "NIMACEMS",
    publication: "NIMASA",
    date: "2025",
    title: "NIMASA unveils model for African maritime decarbonization at COP-30",
    summary:
      "Official NIMASA reporting on the unveiling of a model for African maritime decarbonization at COP-30.",
    url: "https://nimasa.gov.ng/nimasa-unveils-model-for-african-maritime-decarbonization-at-cop-30/",
  },
  {
    country: "Nigeria",
    code: "NIMACEMS",
    publication: "New Telegraph",
    date: "2025",
    title: "NIMASA unveils PPP model for African maritime decarbonisation in Brazil",
    summary:
      "Coverage of NIMASA's PPP model for African maritime decarbonisation, unveiled in Brazil during COP-30.",
    url: "https://newtelegraphng.com/nimasa-unveils-ppp-model-for-african-maritime-decarbonisation-in-brazil/",
  },
  {
    country: "Nigeria",
    code: "NIMACEMS",
    publication: "The Nation Nigeria",
    date: "2025",
    title: "NIMASA commissions Africa's first maritime emissions model at COP30",
    summary:
      "Reporting on NIMASA's commissioning of what is described as Africa's first maritime emissions model at COP30.",
    url: "https://thenationonlineng.net/nimasa-commissions-africas-first-maritime-emissions-model-at-cop30/",
  },

  // ---------- AOCEMS · Corporate / Founder coverage ----------
  {
    country: "AOCEMS",
    code: "AOCEMS",
    publication: "USA News",
    date: "2026",
    title: "Rohit Khattar — the techpreneur powering Africa's green future through real-time emissions intelligence",
    summary:
      "Founder profile on Rohit Khattar and how United Platform Solutions Global is powering Africa's green future through real-time emissions intelligence.",
    url: "https://usanews.com/newsroom/rohit-khattar-the-techpreneur-powering-africas-green-future-through-realtime-emissions-intelligence",
    image: "/imagery/press/rohit-khattar.jpg",
  },
  {
    country: "AOCEMS",
    code: "AOCEMS",
    publication: "Tech Review Africa",
    date: "2026",
    title: "Kenya launches first national digital emissions monitoring platform",
    summary:
      "Coverage of Kenya's launch of the first national digital emissions monitoring platform, powered by AOCEMS.",
    url: "https://techreviewafrica.com/news/4364/kenya-launches-first-national-digital-emissions-monitoring-platform#0",
  },
  {
    country: "AOCEMS",
    code: "AOCEMS",
    publication: "Bizpreneur ME",
    date: "2026",
    title: "Business Leader Spotlight · Rohit Khattar",
    summary:
      "Business leader spotlight on Rohit Khattar, founder of United Platform Solutions Global and architect of AOCEMS.",
    url: "https://www.bizpreneurme.com/business-leader-spotlight-rohit-khattar/",
    image: "/imagery/press/rohit-khattar.jpg",
  },
];

export const mediaCountries = ["All", "Kenya", "Ghana", "Tanzania", "Nigeria", "AOCEMS"];
